
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlC as ObiOwnShipControlCElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-c.js';
 
 
 

 
 export const ObiOwnShipControlC = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-c',
   elementClass: ObiOwnShipControlCElement,
   events: {
     
   }
  });
 
 